import { render } from "./CreateNewJobButton.vue?vue&type=template&id=72b25bd9&ts=true"
import script from "./CreateNewJobButton.vue?vue&type=script&lang=ts"
export * from "./CreateNewJobButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__